import { render, staticRenderFns } from "./LandingBaseModal.vue?vue&type=template&id=61c86367"
import script from "./LandingBaseModal.vue?vue&type=script&lang=js"
export * from "./LandingBaseModal.vue?vue&type=script&lang=js"
import style0 from "./LandingBaseModal.vue?vue&type=style&index=0&id=61c86367&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports